import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_life-architecture/artifacts/q5vdg061_Logo%20Final.png";

const links = [
  { label: "Vision", href: "#vision" },
  { label: "Impact", href: "#impact" },
  { label: "Vault", href: "#vault" },
  { label: "Transition", href: "#transition" },
];

export const Nav = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const update = () => {
      const brandEl = document.querySelector('[data-testid="brand-strip"]');
      if (!brandEl) {
        setShow(window.scrollY > 80);
        return;
      }
      const rect = brandEl.getBoundingClientRect();
      // Show nav once the brand strip's bottom has scrolled above the viewport top
      setShow(rect.bottom <= 40);
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.header
          key="nav"
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed top-0 inset-x-0 z-50 bg-[#030704]/85 backdrop-blur-xl border-b border-white/[0.06]"
          data-testid="main-nav"
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 md:h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 md:gap-4 group"
        >
          <span className="relative inline-flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-lg overflow-hidden bg-white ring-1 ring-[#10B981]/30 group-hover:ring-[#10B981]/70 transition shadow-[0_8px_30px_-6px_rgba(16,185,129,0.35)]">
            <img
              src={LOGO}
              alt="Colossus Biorefinery"
              className="h-full w-full object-contain"
              loading="eager"
            />
            <span className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-lg pointer-events-none" />
          </span>
          <div className="flex flex-col leading-none">
            <span className="font-brand text-lg md:text-2xl text-white tracking-[0.06em]">
              COLOSSUS
            </span>
            <span className="hidden sm:inline-block text-[8px] md:text-[9px] uppercase tracking-[0.35em] text-[#10B981] mt-1">
              Biorefinery
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs uppercase tracking-[0.25em] text-white/60 hover:text-[#10B981] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="mailto:info@colossusbioref.com"
          data-testid="nav-cta-email"
          className="group inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.03] px-4 py-2 text-xs uppercase tracking-[0.2em] text-white/80 hover:border-[#10B981]/60 hover:text-white hover:bg-[#10B981]/10 transition-all"
        >
          <Mail className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Get in touch</span>
        </a>
      </div>
    </motion.header>
      )}
    </AnimatePresence>
  );
};

export default Nav;
